// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608182117/js/" + chunkId + "." + {"44":"0dad876a","225":"c5628088","481":"5dd8fbab","486":"bdaaf0c5","770":"32c60cfb"}[chunkId] + ".0.9434678576620973.chunk.js";
};